export const formatDate = (
    dateString: string,
    options: Intl.DateTimeFormatOptions = {}
): string => {
    const date = new Date(dateString.replace(/-/g, '/'));
    return date.toLocaleDateString(undefined, {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        ...options,
    });
};

const LOCALSTORAGE_KEY = 'welcomeDialogDismissed';

export const isWelcomeDialogDismissed = () => {
    try {
        return localStorage.getItem(LOCALSTORAGE_KEY) === 'true';
    } catch (e) {
        return false;
    }
};

export const dismissWelcomeDialog = () => {
    localStorage.setItem(LOCALSTORAGE_KEY, 'true');
};

export const scroll = (element: HTMLElement | null): void => {
    if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
};
